'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "fallback"];
import PropTypes from 'prop-types';
import { PureComponent, Children, cloneElement } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import HiddenMeasure from './utils/HiddenMeasure';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "UICollapser__Wrapper",
  componentId: "sc-1mbaz6w-0"
})(["position:relative;"]);
class UICollapser extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      useFallback: false
    };
    this.checkFit = () => {
      const {
        useFallback
      } = this.state;
      const overflows = this._wrapEl.scrollHeight > this._nowrapEl.scrollHeight;
      if (useFallback !== overflows) {
        this.setState({
          useFallback: overflows
        });
      }
    };
  }
  componentDidMount() {
    this._resizeObserver = new ResizeObserver(this.checkFit);
    this._resizeObserver.observe(this._nowrapEl);
  }
  componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.useFallback === this.state.useFallback) {
      this.checkFit();
    }
  }
  componentWillUnmount() {
    this._resizeObserver.disconnect();
  }
  render() {
    const _this$props = this.props,
      {
        children,
        fallback
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      useFallback
    } = this.state;
    const childrenClone = Children.map(children, child => {
      if (!child.props) return child;
      const childClassName = child.props.className || '';
      return /*#__PURE__*/cloneElement(child, {
        className: classNames(childClassName, 'display-inline-flex')
      });
    });
    return /*#__PURE__*/_jsxs(Wrapper, Object.assign({}, rest, {
      children: [useFallback ? fallback : childrenClone, /*#__PURE__*/_jsx(HiddenMeasure, {
        className: "display-inline-flex",
        ref: ref => {
          this._nowrapEl = ref;
        },
        children: childrenClone
      }), /*#__PURE__*/_jsx(HiddenMeasure, {
        className: "display-inline-block",
        ref: ref => {
          this._wrapEl = ref;
        },
        children: childrenClone
      })]
    }));
  }
}
UICollapser.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node.isRequired
};
UICollapser.displayName = 'UICollapser';
export default UICollapser;